import { type ModuleKey, moduleLabel } from '@estac1/shared';
import { Badge, Card, CardContent } from '@estac1/ui';
import { Check, CircleAlert } from 'lucide-react';
import { type ClientOverview, day } from './types.js';

const MODULE_STATUS: Record<string, string> = {
  active: 'ativo',
  trialing: 'em teste',
  canceled: 'cancelado',
  off: 'desligado',
};

/** Módulos, o que falta configurar e o que deu errado nos últimos 30 dias (#656). */
export const HealthSection = ({ data }: { data: ClientOverview }) => (
  <div className="grid gap-3 md:grid-cols-3">
    <Card>
      <CardContent className="space-y-2 pt-6">
        <p className="text-sm font-medium">Módulos</p>
        <ul className="space-y-1 text-sm">
          {data.modules.length === 0 && <li className="text-muted-fg">Nenhum módulo ligado.</li>}
          {data.modules.map((m) => (
            <li key={m.key} className="flex items-center justify-between gap-2">
              <span>{moduleLabel(m.key as ModuleKey).split(' — ')[0]}</span>
              <Badge
                variant={
                  m.status === 'active' ? 'success' : m.status === 'trialing' ? 'brand' : 'default'
                }
              >
                {MODULE_STATUS[m.status] ?? m.status}
                {m.status === 'trialing' && m.trialEndsAt ? ` até ${day(m.trialEndsAt)}` : ''}
              </Badge>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="space-y-2 pt-6">
        <p className="text-sm font-medium">Configuração</p>
        <ul className="space-y-1 text-sm">
          {data.setup.map((s) => (
            <li key={s.key} className="flex items-center gap-2">
              {s.done ? (
                <Check className="h-4 w-4 text-success" aria-hidden="true" />
              ) : (
                <CircleAlert className="h-4 w-4 text-warning" aria-hidden="true" />
              )}
              <span className={s.done ? '' : 'font-medium'}>{s.label}</span>
              {!s.done && <span className="text-xs text-muted-fg">falta</span>}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="space-y-2 pt-6">
        <p className="text-sm font-medium">Problemas nos últimos 30 dias</p>
        {data.problems.length === 0 ? (
          <p className="text-sm text-muted-fg">Nada fora do normal.</p>
        ) : (
          <ul className="space-y-1 text-sm">
            {data.problems.map((p) => (
              <li key={p.key} className="flex items-center justify-between gap-2">
                <span>{p.label}</span>
                <Badge variant="danger">{p.count}</Badge>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  </div>
);
